import { BrowserRouter, Routes, Route, Navigate, useLocation } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { CartProvider } from "@/context/CartContext";
import Landing from "@/pages/Landing";
import Browse from "@/pages/Browse";
import Checkout from "@/pages/Checkout";
import Dashboard from "@/pages/Dashboard";
import UntukRekanMasak from "@/pages/UntukRekanMasak";
import UntukPembeli from "@/pages/UntukPembeli";
import AuthCallback from "@/pages/AuthCallback";
import ContactWidget from "@/components/ContactWidget";
import AuthErrorModal from "@/components/AuthErrorModal";
import "@/App.css";

const Loading = () => (
  <div className="min-h-screen flex items-center justify-center">
    <p className="font-mono-c text-sm" style={{ color: "var(--muted)" }}>Memuat...</p>
  </div>
);

const Protected = ({ children }) => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (!user) return <Navigate to="/" replace />;
  return children;
};

const PublicHome = () => {
  const { user, loading } = useAuth();
  if (loading) return <Loading />;
  if (user) return <Navigate to="/menu" replace />;
  return <Landing />;
};

function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <Routes>
      <Route path="/" element={<PublicHome />} />
      <Route path="/untuk-rekan-masak" element={<UntukRekanMasak />} />
      <Route path="/untuk-pembeli" element={<UntukPembeli />} />
      <Route path="/menu" element={<Protected><Browse /></Protected>} />
      <Route path="/dashboard" element={<Protected><Dashboard /></Protected>} />
      <Route path="/checkout" element={<Protected><Checkout /></Protected>} />
      <Route path="*" element={<Navigate to="/" replace />} />
    </Routes>
  );
}

export default function App() {
  return (
    <BrowserRouter>
      <AuthProvider>
        <CartProvider>
          <AppRouter />
          <AuthErrorModal />
          <ContactWidget />
          <Toaster position="top-center" />
        </CartProvider>
      </AuthProvider>
    </BrowserRouter>
  );
}
